export function normalizeEventAttachments(list) {
  if (!Array.isArray(list)) return [];

  return list
    .map((item) => ({
      id: String(item?.id || "").trim(),
      label: String(item?.label || "").trim(),
      url: String(item?.url || "").trim(),
      file_name: String(item?.file_name || "").trim(),
      storage_path: String(item?.storage_path || "").trim(),
      content_type: String(item?.content_type || "").trim(),
      size_bytes: Number.isFinite(Number(item?.size_bytes)) ? Number(item.size_bytes) : 0,
    }))
    .filter((item) => item.url || item.storage_path);
}

export function getAttachmentDisplayName(item) {
  const normalized = item || {};
  return (
    String(normalized.label || "").trim() ||
    String(normalized.file_name || "").trim() ||
    String(normalized.url || "").trim() ||
    "Attachment"
  );
}

export function isUploadedAttachment(item) {
  return Boolean(String(item?.storage_path || "").trim());
}